import { useEffect } from "react";

// Calls `onAway` when a mousedown lands outside `ref` or Escape is pressed.
// Listeners are only attached while `enabled` (default true), so callers can
// gate it on an open/closed flag instead of juggling addEventListener. Pass a
// stable `onAway` (e.g. via useCallback) so the listeners aren't re-attached on
// every render.
export default function useClickAway(ref, onAway, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const onPointerDown = (e) => {
      if (!ref.current?.contains(e.target)) onAway();
    };
    const onKey = (e) => {
      if (e.key === "Escape") onAway();
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [ref, onAway, enabled]);
}
